import React, { useState, useEffect } from "react";
import Formulario from "./components/Formulario";
import Cita from "./components/Cita";

function App() {
	//Citas en loca storage
	let citasIniciales = JSON.parse(localStorage.getItem("citas"));
	if (!citasIniciales) {
		citasIniciales = [];
	}

	//Arreglo de citas
	const [citas, guardarCitas] = useState(citasIniciales ? citasIniciales : [])

	//Use Effect para realizar ciertas operaciones cuando el state cambia
	useEffect(() => {
		let citasIniciales = JSON.parse(localStorage.getItem("citas"));
		if (citasIniciales) {
			localStorage.setItem("citas", JSON.stringify(citas));
		} else {
			localStorage.setItem("citas", JSON.stringify([]));
		}
	}, [citas]);

	//Funcion que tome las citas actuales y agruege la nueva
	const crearCita = (cita) => {
		console.log("crearCita");
		console.log(cita);
		guardarCitas([...citas, cita]);
		console.log(citas);
	};

	//Funcion que eliminar una cita por su id
	const eliminarCita = (id) => {
		console.log("eliminarCita");
		console.log(id);
		const nuevasCitas = citas.filter((cita) => cita.id !== id);
		guardarCitas(nuevasCitas);
	};

	//Mensaje condicional
	const titulo = citas.length === 0 ? "No hay citas" : "Administra tus Citas";

	return (
		<React.Fragment>
			<h1>Administrador de Pacientes (Alexis)</h1>
			<div className="container">
				<div className="row">
					<div className="one-half column">
						<Formulario crearCita={crearCita} />
					</div>
					<div className="one-half column">
						<h2>{titulo}</h2>
						{citas.map((cita) => (
							<Cita
								key={cita.id}
								cita={cita}
								eliminarCita={eliminarCita}
							/>
						))}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}


export default App;
